<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct">
    !
  </div>
<div class="pepiv">
<i>Jesus is dead, Marx is dead, Elvis is dead</i><br/>
<i>And I’m not feeling too good myself</i>
</div>
<div class="peps">
    —A T-SHIRT IN SANTA MONICA
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alex_9781571318060_oeb_p01_r1.vue?084e1465